const base = '/recruit',
    basePath = `pages${base}`;
export default [
    {
        path:`/candidate/index`,
        name:'candidateIndex',
        component:r => require.ensure([], () => r(require(`@/${basePath}/candidate/index`)), 'candidate'),
        meta:{
            tit:'我的候选人'
        }
    },
    {
        path:`/candidates/index`,
        name:'candidatesIndex',
        component:r => require.ensure([], () => r(require(`@/${basePath}/candidates/index`)), 'candidatesIndex'),
        meta:{
            tit:'所有候选人'
        }
    },
    {
        path:`/users/index`,
        name:'usersIndex',
        component:r => require.ensure([], () => r(require(`@/${basePath}/users/index`)), 'usersIndex'),
        meta:{
            tit:'用户管理'
        }
    },
    {
        path:`/users/detail`,
        name:'usersDetail',
        component:r => require.ensure([], () => r(require(`@/${basePath}/users/detail`)), 'usersDetail'),
        meta:{
            tit:'用户管理详情'
        }
    },
    {
        path:`/job/index`,
        name:'jobIndex',
        component:r => require.ensure([], () => r(require(`@/${basePath}/job/index`)), 'jobIndex'),
        meta:{
            tit:'个人职位管理'
        }
    },
    {
        path:`/job/detail`,
        name:'jobDetail',
        component:r => require.ensure([], () => r(require(`@/${basePath}/job/detail`)), 'jobDetail'),
        meta:{
            tit:'个人职位候选人'
        }
    },
    {
        path:`/job/edit`,
        name:'jobEdit',
        component:r => require.ensure([], () => r(require(`@/${basePath}/job/edit`)), 'jobEdit'),
        meta:{
            tit:'个人职位编辑'
        }
    },


    {
        path:`/jobs/index`,
        name:'jobsIndex',
        component:r => require.ensure([], () => r(require(`@/${basePath}/jobs/index`)), 'jobsIndex'),
        meta:{
            tit:'全部职位管理'
        }
    },
    {
        path:`/jobs/edit`,
        name:'jobsEdit',
        component:r => require.ensure([], () => r(require(`@/${basePath}/jobs/edit`)), 'jobsEdit'),
        meta:{
            tit:'全部职位编辑'
        }
    },
    {
        path:`/jobs/detail`,
        name:'jobsDetail',
        component:r => require.ensure([], () => r(require(`@/${basePath}/jobs/detail`)), 'jobsDetail'),
        meta:{
            tit:'全部职位候选人'
        }
    },
]


// WEBPACK FOOTER //
// ./src/router/router/recruit.js